import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'tipo-contato';
const route = {
  tipoContatoList: `${baseRef}/combo`,
  listarTodos: `${baseRef}/todos`,
  tipoContatoTelaPermitidaList: (nomeTela: String) => `${baseRef}/combo?telaPermitida=${nomeTela}`,
};

@Injectable({
  providedIn: 'root'
})
export class TipoContatoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar() {
    return this.domainCache.getOrLoad(route.tipoContatoList, () =>
      this.apiService.get<any[]>(route.tipoContatoList, undefined, undefined, true)
    );
  }

  tipoContatoTelaPermitidaList(nomeTela: string) {
    const key = `tipo-contato/combo?telaPermitida=${nomeTela}`;
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<any[]>(route.tipoContatoTelaPermitidaList(nomeTela), undefined, undefined, true)
    );
  }

  listarTodos(): Observable<any> {
    return this.http.get<any[]>(route.listarTodos);
  }
}
